import { render, staticRenderFns } from "./SpaceLight.vue?vue&type=template&id=34e05fbb&scoped=true"
import script from "./SpaceLight.vue?vue&type=script&lang=js"
export * from "./SpaceLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e05fbb",
  null
  
)

export default component.exports